import type { ContributionHistoryFilters, ContributionHistoryItem } from "@/api/contributions.api";
import { localDay, normalizeStatus, type HistoryEntry, type HistoryFilters, type HistoryKind } from "./contribution-history";

export const HISTORY_PAGE_SIZE = 10;

/** The server query for one page: status, language and dates are filtered there. */
export function historyParams(filters: HistoryFilters, page: number, limit = HISTORY_PAGE_SIZE): ContributionHistoryFilters {
  return {
    page,
    limit,
    ...(filters.status !== "all" ? { statut: filters.status } : {}),
    ...(filters.language !== "all" ? { langue: filters.language } : {}),
    ...(filters.from ? { dateDebut: `${filters.from}T00:00:00` } : {}),
    // Inclusive day: up to its last millisecond.
    ...(filters.to ? { dateFin: `${filters.to}T23:59:59.999` } : {}),
  };
}

function kindOf(contentType: string | null | undefined): HistoryKind {
  const value = (contentType ?? "").toLowerCase();
  if (value === "audio") return "audio";
  if (value === "text") return "text";
  return "other";
}

/** One server entry as the page shows it. */
export function toHistoryEntry(item: ContributionHistoryItem): HistoryEntry {
  const date = item.date ? new Date(item.date) : null;
  const valid = date && !Number.isNaN(date.getTime()) ? date : null;
  return {
    key: item.id,
    date: valid,
    day: valid ? localDay(valid) : null,
    language: item.language ?? null,
    kind: kindOf(item.contentType),
    status: normalizeStatus(item.status),
    blobName: typeof item.blobName === "string" && item.blobName ? item.blobName : null,
  };
}
